<template>
    <v-dialog v-model="show" persistent max-width="600px" max-height="400px">
        <!-- <div id="app"> -->
        <!-- <v-app id="inspire"> -->
        <v-card class="d-flex flex-column" style="max-height: 400px; overflow: hidden;">
            <v-card-title>
                <span class="text-h5">Editar Cliente N° {{ numcliente }}</span>
            </v-card-title>
            <v-card-text style="overflow: auto; flex-grow: 1;">
                <!-- <v-container> -->
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-text-field label="Nombre del Cliente" v-model="nomcliente" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="codigo" label="Código ICSSA"></v-text-field>
                    </v-col>
                </v-row>
                <!-- </v-container> -->
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="show = false">
                    Cerrar
                </v-btn>
                <v-btn color="blue darken-1" text @click="guardarcliente()">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
        <!-- </v-app> -->
        <!-- </div> -->
    </v-dialog>
</template>
<script>
import axios from "../../../axios-auth";
export default {
    data: (vm) => ({
    }),
    props: ["visible", "numcliente", "nomcliente", "codigo"],
    computed: {
        show: {
            get() {
                //this.cargardatos(false);
                return this.visible;
            },
            set(value) {
                if (!value) {
                    //this.$refs.form.resetValidation();
                    //this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        guardarcliente() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Cliente",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        numcliente: this.numcliente,
                        nomcliente: this.nomcliente,
                        codigo: this.codigo,

                    };

                    let self = this;
                    axios
                        .post("/Ingenieria/GuardarCliente", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Cliente guardado con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            setTimeout(() => {
                                self.$router.push({ name: "IngListadoCliente" });
                            }, 2000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        vaciarListado() {
            // this.listado = [];
            // this.numcliente = "";
            // this.nomcliente = "";
            // this.codigo = "";
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 1500,
            });
        },
    },
};
</script>